import * as Font from "expo-font";

// fonts preloading
export const fontAssets = [
  {
    "OpenSans-Bold": require("./OpenSans-Bold.ttf"),
  },{
    "Roboto": require("./Roboto-Regular.ttf"),
  },{
    "Roboto-Light": require("./Roboto-Light.ttf"),
  },{
    "Roboto-Medium": require("./Roboto-Medium.ttf"),
  },{
    "Roboto-Bold": require("./Roboto-Bold.ttf"),
  },{
    "Inter-Bold": require("./Inter-Bold.ttf"),
  },{
    "Montserrat": require("./Montserrat-Regular.ttf"),
  },{
    "Montserrat-Light": require("./Montserrat-Light.ttf"),
  },{
    "Montserrat-Medium": require("./Montserrat-Medium.ttf"),
  },{
    "Montserrat-Bold": require("./Montserrat-Bold.ttf"),
  },{
    "Montserrat-Black": require("./Montserrat-Black.ttf"),
  },{
    "Montserrat-ExtraBold": require("./Montserrat-ExtraBold.ttf"),
  },
].map((x: any) => Font.loadAsync(x));
